import { z } from "zod/v4-mini";

/**
 * AGPStatsModel
 *
 * Partial object of the agp stats
 * TODO STE-1608 find out what the real object looks like
 */
export type AGPStats = Record<
  number,
  {
    "5": number;
    "25": number;
    "50": number;
    "75": number;
    "95": number;
  }
>;

export const agpStatsSchema = z.record(
  z.number(),
  z.object({
    "5": z.number(),
    "25": z.number(),
    "50": z.number(),
    "75": z.number(),
    "95": z.number(),
  }),
);
